import { Button, Modal, Table, Typography } from 'antd';
import type { ColumnsType } from 'antd/lib/table';

import useLocale from '../../../hooks/useLocale';
import { EMPTY_VALUE, RESULT_MODAL_WIDTH } from './constants';
import type { IActionFailure, IActionOutcome } from './types';
import { formatText, getActionReasonText } from './utils';

interface IProps {
  outcome: IActionOutcome;
  onClose: () => void;
}

const ActionResultModal = ({ outcome, onClose }: IProps): JSX.Element => {
  const { t } = useLocale();
  const { title, summary } = outcome;

  const columns: ColumnsType<IActionFailure> = [
    {
      title: t.INTEGRATION_COMMAND,
      dataIndex: 'label',
      key: 'label',
      render: (label?: string) => label ?? EMPTY_VALUE,
    },
    {
      title: t.INTEGRATION_ID,
      dataIndex: 'id',
      key: 'id',
      render: (id: string) => (
        <Typography.Text code copyable>
          {id}
        </Typography.Text>
      ),
    },
    {
      title: t.REASON,
      dataIndex: 'reason',
      key: 'reason',
      render: (reason?: string) => getActionReasonText(reason, t),
    },
  ];

  return (
    <Modal
      open
      title={title}
      width={RESULT_MODAL_WIDTH}
      onCancel={onClose}
      footer={
        <Button type="primary" onClick={onClose}>
          {t.CLOSE}
        </Button>
      }
    >
      <Typography.Paragraph>
        {formatText(t.INTEGRATION_RESULT_SUMMARY, summary.succeededCount, summary.failures.length)}
      </Typography.Paragraph>
      <Table size="small" rowKey="id" columns={columns} dataSource={summary.failures} pagination={false} />
    </Modal>
  );
};

export default ActionResultModal;
